import * as XLSX from "xlsx";

/**
 * JSON 데이터를 Excel로 다운로드
 * @param {Array<Object>} data - JSON 배열 (tableData 같은 구조)
 * @param {String} fileName - 저장될 파일명 (확장자 없이)
 * @param {Object} [headerMap] - 키 변경을 위한 매핑 (ex: { regDt: '시간', value: '측정값' })
 */
export function downloadExcel(data, fileName = "export", headerMap = null) {
    if (!Array.isArray(data) || data.length === 0) {
        console.warn("엑셀로 내보낼 데이터가 없습니다.");
        return;
    }

    let exportData = data;

    if (headerMap) {
        exportData = data.map((item) => {
            const mapped = {};
            for (const key in headerMap) {
                mapped[headerMap[key]] = item[key];
            }
            return mapped;
        });
    }

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // 엑셀 파일 작성 및 다운로드
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
    const blob = new Blob([s2ab(excelBuffer)], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `${fileName}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

function s2ab(s) {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < s.length; ++i) view[i] = s.charCodeAt(i);
    return buf;
}
